import { useQuery } from "@apollo/client";
import GetGatheringForUsersPreviewDocument from "src/api/graphql/__generated__/documents/GetGatheringForUsersPreviewDocument";
import MiniCardUsersPreview from "src/components/MiniCard/components/MiniCardUsersPreview";
import { getClientId } from "src/helpers/globalHelpers";

const GatheringParticipantsPreview = ({ gatheringId }: { gatheringId: string }) => {
	const { data } = useQuery(GetGatheringForUsersPreviewDocument, {
		fetchPolicy: "cache-first",
		variables: {
			input: {
				gatheringId,
			},
			usersInput: {
				limit: 3,
			},
		},
	});
	const userIds = (data?.getGathering?.users?.payload ?? []).map((user) => user.userId);

	return <MiniCardUsersPreview userIds={userIds.length === 0 ? [getClientId()] : userIds} />;
};
export default GatheringParticipantsPreview;
